import { useMutation, useQueryClient } from 'react-query'
import { api } from '../../../../services/api'

const cadastrarCliente = async (clienteData) => {
  const response = await api.post('/site/v2/cadastro-cliente/cadastro-apas', clienteData)
  return response.data
}

export const useClientesMutation = () => {
  const queryClient = useQueryClient()

  return useMutation(cadastrarCliente, {
    onSuccess: () => {
      queryClient.invalidateQueries('clientes-apas')
    },
  })
}
